import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as projectStagesServiceClear } from './projectStagesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'projectStages',
  serviceTableName: 'projectStagesService',
  serviceClearFunction: projectStagesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.projectStage]),
});
